import { LatLngAlt } from "../../../types.js";

const stream: LatLngAlt[] = [
  [55.640114, -5.240407, 53.6],
  [55.640184, -5.240524, 53.6],
  [55.640243, -5.240662, 53.6],
  [55.640323, -5.240762, 53.6],
  [55.640414, -5.240809, 53.6],
  [55.640516, -5.240802, 53.6],
  [55.640613, -5.240741, 53.6],
  [55.640683, -5.240625, 53.6],
  [55.640731, -5.240467, 53.6],
  [55.640752, -5.240291, 53.6],
  [55.640779, -5.240117, 53.6],
  [55.640849, -5.239985, 53.6],
];

export default stream;
